module.exports = __webpack_public_path__ + "img/Wp_2032.7686041e.png";